//eslint-disable
import React, { useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import Congif from "./connecting.gif";

export default function Video({ session, setCollocation }) {
  const history = useHistory();
  const ref = useRef("videRef");

  React.useEffect(() => {
    if (session.session?._callState === "connected") {
      setCollocation("");
      history.push("/callinprogress");
    }
  }, [session]);
  
  const renderVideo = useMemo(
    () => (
      <>
        {window?.config?.promoVideo ? (
          <>
            <img
              src={Congif}
              width="600"
              height="80"
              style={{ marginLeft: "4vw" }}
            />
            <video
              src={
                //   window?.config?.promoVideo === undefined || ""
                //     ? "promovideo.mp4"  :
                window?.config?.promoVideo
              }
              // src="promovideo.mp4"
              ref={ref}
              autoPlay
              loop
              playsInline
              id="promo"
              style={{
                objectFit: "contain",
                minHeight: "49%",
                minWidth: "63%",
                maxHeight: "43vh",
                maxWidth: "63%",
                justifyContent: "center",
                marginTop: "5vh",
                marginBottom: "5vh",
                backgroundColor: "#eff3f6",
              }}
            />
          </>
        ) : (
          <>
            <img
              src={Congif}
              // width={isMatch?"300":"600"}
              // height={isMatch?"80":"120"}
              style={{
                alignContent: "center",
                marginTop: "20vh",
                width: "70%",
                height: "15%",
              }}
            />
          </>
        )}
      </>
    ),
    [session]
  );

  return (
    <>
      <div
        style={{ marginTop: "25vh", marginLeft: "25vw" }}
        key={Math.random()}
      >
        {renderVideo}
      </div>
    </>
  );
}

Video.propTypes = {
  session: PropTypes.any,
  setCollocation: PropTypes.any,
};
